module.exports = __webpack_public_path__ + "img/ag-drive-logo-sidebar.91f0d85a.svg";